import {Component, Inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {AuthService, HeaderAction, HeaderMenuLink, LanguageLink} from 'ais-common';
import { Subscription } from 'rxjs';
import { AppStateService } from './app-state.service';
import { VSKDokument } from './model/vsk-dokument';
import {TranslateService} from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

  title = 'Dokument';
  userName: string;
  aisLandingPage: string;
  // languageLinks: LanguageLink[] = [];

  headerActions: HeaderAction[] = [];

  httpParams: HttpParams = new HttpParams();

  private dataSubscription: Subscription;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private authService: AuthService,
    private appStateService: AppStateService,
    public translateService: TranslateService,
    private route: ActivatedRoute
  ) {

    translateService.use(locale);

  }

  ngOnInit(): void {

    this.authService.initAccessTokenSession();

    this.dataSubscription = this.appStateService.dataFetched
    .subscribe((data: VSKDokument) => {

      // console.log('user: ' + data.user);
      // console.log('aisLandingPage: ' + data.aisLandingPage);
      this.title = this.translateService.instant('Dokument');
      this.userName = data.user;
      const lng = this.locale.toLowerCase();
      this.aisLandingPage = data.aisLandingPage.replace('{lng}', lng);

      // console.log("app.component.ts data fetched")


      // this.languageLinks = [];
      // if (data.jazykyPortalu) {
      //   data.jazykyPortalu.forEach(value => {
      //     this.languageLinks.push(new LanguageLink('..\\' + value.toLowerCase(), value.toUpperCase()));
      //   });
      // }

      this.route.queryParams.subscribe(
        (params) => {

          if (params.idTypDokumentu) {
            let idTypDokumentuTextu = +params.idTypDokumentu;
            if (idTypDokumentuTextu === null) {
              idTypDokumentuTextu = 1;
            }
            this.httpParams = this.httpParams.set('idTypDokumentu', idTypDokumentuTextu);
          }

          if (params.idStudProgram) {
            let idStudProgram = +params.idStudProgram;
            if (idStudProgram === null) {
              idStudProgram = 0;
            }

            this.httpParams = this.httpParams.set('idStudProgram', idStudProgram);
          }

          if (params.haik) {
            this.httpParams = this.httpParams.set('haik', params.haik);
          }

          if (params.idOsoba) {
            let idOsoby = +params.idOsoba;
            if (idOsoby === null) {
              idOsoby = 0;
            }

            this.httpParams = this.httpParams.set('idOsoba', idOsoby);
          }

          if (params.idPodprogram) {
            let idPodprogram = +params.idPodprogram;
            if (idPodprogram === null) {
              idPodprogram = 0;
            }

            this.httpParams = this.httpParams.set('idPodprogram', idPodprogram);
          }

          if (params.akRok) {
            this.httpParams = this.httpParams.set('akRok', params.akRok);
          }

          if (params.fakulta) {
            this.httpParams = this.httpParams.set('fakulta', params.fakulta);
          }

          if (params.jazyk) {
            this.httpParams = this.httpParams.set('jazyk', params.jazyk);
          }

          // let path = '..\\' + lng;
          // if (this.httpParams.keys().length > 0) {
          //   const path = this.httpParams.toString();
          //   console.log('path=' + path);
          // }

        }
    );


      this.setHeaderMenu();

    });

  }

  setHeaderMenu() {

    this.headerActions = [];

    this.headerActions.push(
      new HeaderMenuLink('AiS2',
        this.aisLandingPage,
        'arrow_back'
      )
    );

  }


  ngOnDestroy() {
    this.dataSubscription.unsubscribe();
  }

}
